export default class TimeSeriesAPIService {
  constructor($http, appSettings, $timeout) {
    'ngInject';
    this.$http = $http;
    this.$timeout = $timeout;
    this.appSettings = appSettings;
    this.icebergApiTimeSeries = this.appSettings.IcebergApiTimeSeries;
  }

  getAssetSeries(assetIds = []) {
    const filter = {
      criteria: { owners: assetIds },
    };
    const endpoint = `${this.icebergApiTimeSeries}/series/_filter`;
    return this.$http.post(endpoint, filter).then((res) => res.data);
  }

  getSeriesData(range, seriesId = [], functions = [], interval, timezone) {
    const r = `range=${range}`;
    const ids = seriesId.length ? `&${seriesId.map((id) => `id=${id}`).join('&')}` : '';
    const funcs = functions.length ? `&functions=${functions.join(',')}` : '';
    const intr = interval ? `&interval=${interval}` : '';
    const tz = timezone ? `&tz=${timezone}` : '';
    const queryString = `${r}${ids}${funcs}${intr}${tz}`;

    const endpoint = `${this.icebergApiTimeSeries}/data?${queryString}`;
    return this.$http.get(endpoint).then((res) => res.data);
  }

  pinLocation(seriesID, coordinates) {
    return this.$http.put(`${this.icebergApiTimeSeries}/series/${seriesID}/data/pin`, coordinates);
  }

  unpinLocation(seriesID) {
    return this.$http.patch(`${this.icebergApiTimeSeries}/series/${seriesID}/data/unpin`);
  }

  createSeries(equipmentID, title, dataPoint, valueType) {
    const series = {
      key: `equipment:${equipmentID}.${dataPoint}`,
      title: title,
      tags: [dataPoint],
      valueType: valueType,
      attrs: {
        equipment: equipmentID,
      },
    };
    return this.$http.post(`${this.icebergApiTimeSeries}/series`, series);
  }

  setLocation(seriesID, isPinned = true, coordinates, equipmentID) {
    var promise;
    if (isPinned && !!seriesID)
      promise = this.unpinLocation(seriesID).then(() => {
        if (!coordinates) {
          // Timeout is needed so that when it is not repinning that it is able to get the last pinned location for the location history
          return this.$timeout(3000);
        }
      });

    if (coordinates) {
      if (!seriesID) {
        promise = this.createSeries(equipmentID, 'Location', 'gps', 4).then(({ data }) => {
          seriesID = data.id;
          // Time out is needed because pinning a location right after the series is created will not save it.
          return this.$timeout(3000);
        });
      }

      if (promise) {
        promise.then(() => {
          return this.pinLocation(seriesID, coordinates);
        });
      } else {
        promise = this.pinLocation(seriesID, coordinates);
      }
    }
    return promise;
  }
}
